import React from "react";
import PropTypes from "prop-types";

import CancelIcon from "@material-ui/icons/Cancel";
import Chip from "@material-ui/core/Chip";
import { components } from "react-select";
import styles from "components/select/react-select-styles";

const MultiValueRemove = props => (
  <components.MultiValueRemove {...props}>
    <CancelIcon />
  </components.MultiValueRemove>
);

const MultiValueContainer = props => {
  const { children } = props;
  return (
    <Chip
      tabIndex={-1}
      label={children}
      style={styles.chip}
      className={styles.chip}
    />
  );
};

export { MultiValueRemove, MultiValueContainer };
